import { Controller } from "@hotwired/stimulus";
import { Chart } from "chart.js/auto";

export default class extends Controller {
  connect() {
    const canvas = document.createElement("canvas");
    canvas.className = "chart-canvas";

    this.element.style.position = "relative";
    this.element.appendChild(canvas);

    const values = JSON.parse(this.element.dataset.chartValues);

    this.chartInstance = new Chart(canvas, values);
  }

  disconnect() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  }
}